import { weeklySummariesResponseSchema } from '@si/types';
import { get } from '@si/utils';
import { useQuery } from '@tanstack/react-query';

import { queryKeys } from './queryKeys';

interface Params {
  projectId: string;
  enabled?: boolean;
  limit?: number;
}

export function useWeeklySummaries({ projectId, enabled = true, limit }: Params) {
  const url = `/projects/${projectId}/weekly-summaries${limit ? `?limit=${limit}` : ''}`;

  const { data, error, isLoading } = useQuery({
    queryKey: queryKeys.getWeeklySummaries(projectId, limit),
    queryFn: () => get({ url, schema: weeklySummariesResponseSchema }),
    enabled: enabled && !!projectId,
  });

  return {
    weeklySummaries: data?.weeklySummaries || [],
    error,
    isLoading,
  };
}
